module.exports = __webpack_public_path__ + "img/public/SiteIcons/complete.svg?21fa7632";